import { Select as StyledSelect, breakpoints } from '@gassan-ui'
import { useBreakpoint } from '@lib/hooks/useBreakpoint'
import { ringSizes } from '@lib/ringSizes'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import styled from 'styled-components'

type Props = {
  onChangeSize: (size: string) => void
  size: string
}

const Select = styled(StyledSelect)`
  z-index: 0;
  &:focus {
    z-index: 1;
  }
`

const SelectSize: FC<Props> = ({ onChangeSize, size }) => {
  const isDesktop = useBreakpoint(breakpoints.large)
  const { t } = useTranslation('other')
  const prefix = !isDesktop ? t('size') : ''

  return (
    <Select
      value={size}
      onChange={(e) => onChangeSize(e.target.value)}
      style={{ marginLeft: '-1px' }}
    >
      <option value="dont-know">{t('iDontKnow')}</option>
      {ringSizes.map((size, _) => (
        <option value={`${size}mm`} key={size}>
          {prefix}
          {size}
        </option>
      ))}
    </Select>
  )
}

export default SelectSize
